"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var DefaultBrowserBehavior_1 = require("../browserbehavior/DefaultBrowserBehavior");
/**
 * A device that augments a {@link Device} to apply Amazon Voice Focus
 * noise suppression to an audio input.
 */
var VoiceFocusTransformDevice = /*#__PURE__*/function () {
  /** @internal */
  function VoiceFocusTransformDevice(device, voiceFocus, delegate, nodeOptions) {
    var failed = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var node = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
    var browserBehavior = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : new DefaultBrowserBehavior_1.default();
    var farEndStreamToAudioSourceNode = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : new Map();
    var mixDestNode = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : undefined;
    var mixSourceNode = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : undefined;
    _classCallCheck(this, VoiceFocusTransformDevice);
    this.device = device;
    this.voiceFocus = voiceFocus;
    this.delegate = delegate;
    this.nodeOptions = nodeOptions;
    this.failed = failed;
    this.node = node;
    this.browserBehavior = browserBehavior;
    this.farEndStreamToAudioSourceNode = farEndStreamToAudioSourceNode;
    this.mixDestNode = mixDestNode;
    this.mixSourceNode = mixSourceNode;
  }
  /**
   * Return the inner device as provided during construction, or updated via
   * {@link VoiceFocusTransformDevice.chooseNewInnerDevice}. Do not confuse
   * this method with {@link VoiceFocusTransformDevice.intrinsicDevice}.
   */
  _createClass(VoiceFocusTransformDevice, [{
    key: "getInnerDevice",
    value: function getInnerDevice() {
      return this.device;
    }
    /**
     * Disable the audio node while muted to reduce CPU usage.
     *
     * @param muted whether the audio device should be muted.
     */
  }, {
    key: "mute",
    value: function mute(muted) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.node) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              if (!muted) {
                _context.next = 7;
                break;
              }
              _context.next = 5;
              return this.node.disable();
            case 5:
              _context.next = 9;
              break;
            case 7:
              _context.next = 9;
              return this.node.enable();
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /**
     * Dispose of the inner workings of the transform device. After this method is called
     * you will need to create a new device to use Amazon Voice Focus again.
     */
  }, {
    key: "stop",
    value: function stop() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.node) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              this.node.disconnect();
              _context2.next = 5;
              return this.node.stop();
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
    /**
     * If you wish to choose a different inner device, but continue to use Amazon Voice Focus, you
     * can use this method to efficiently create a new device that will reuse
     * the same internal state. Only one of the two devices can be used at a time: switch
     * between them using {@link DeviceController.chooseAudioInputDevice}.
     *
     * If the same device is passed as is currently in use, `this` is returned.
     *
     * @param inner The new inner device to use.
     */
  }, {
    key: "chooseNewInnerDevice",
    value: function chooseNewInnerDevice(inner) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(this.device === inner && !isDefaultDevice(inner))) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", this);
            case 2:
              return _context3.abrupt("return", new VoiceFocusTransformDevice(inner, this.voiceFocus, this.delegate, this.nodeOptions, this.failed, this.node, this.browserBehavior, this.farEndStreamToAudioSourceNode, this.mixDestNode, this.mixSourceNode));
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "intrinsicDevice",
    value: function intrinsicDevice() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var isUsingES, trackConstraints, useBuiltInAGC;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!this.failed) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return", this.device);
            case 2:
              isUsingES = this.nodeOptions.es; // Turn the Device into constraints with appropriate AGC settings.
              trackConstraints = {
                echoCancellation: !isUsingES,
                // @ts-ignore
                googEchoCancellation: !isUsingES,
                // @ts-ignore
                googEchoCancellation2: !isUsingES,
                noiseSuppression: false,
                // @ts-ignore
                googNoiseSuppression: false,
                // @ts-ignore
                googHighpassFilter: false,
                // @ts-ignore
                googNoiseSuppression2: false
              };
              if (this.nodeOptions && this.nodeOptions.agc !== undefined) {
                useBuiltInAGC = this.nodeOptions.agc.useBuiltInAGC;
              } else {
                useBuiltInAGC = true;
              }
              trackConstraints.autoGainControl = useBuiltInAGC;
              // @ts-ignore
              trackConstraints.googAutoGainControl = useBuiltInAGC;
              // @ts-ignore
              trackConstraints.googAutoGainControl2 = useBuiltInAGC;
              // Empty string and null.
              if (this.device) {
                _context4.next = 10;
                break;
              }
              return _context4.abrupt("return", trackConstraints);
            case 10:
              if (!(typeof this.device === 'string')) {
                _context4.next = 13;
                break;
              }
              /* istanbul ignore if */
              if (this.browserBehavior.requiresNoExactMediaStreamConstraints()) {
                trackConstraints.deviceId = this.device;
              } else {
                trackConstraints.deviceId = {
                  exact: this.device
                };
              }
              return _context4.abrupt("return", trackConstraints);
            case 13:
              if (!this.device.id) {
                _context4.next = 15;
                break;
              }
              return _context4.abrupt("return", this.device);
            case 15:
              return _context4.abrupt("return", Object.assign(Object.assign({}, this.device), trackConstraints));
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "createAudioNode",
    value: function createAudioNode(context) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var agc, options, _iterator, _step, stream, start, end;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(((_a = this.node) === null || _a === void 0 ? void 0 : _a.context) === context)) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return", {
                start: this.node,
                end: this.node
              });
            case 2:
              agc = {
                useVoiceFocusAGC: false
              };
              options = Object.assign({
                enabled: true,
                agc: agc
              }, this.nodeOptions);
              _context5.prev = 4;
              (_b = this.node) === null || _b === void 0 ? void 0 : _b.disconnect();
              _context5.next = 8;
              return this.voiceFocus.createNode(context, options);
            case 8:
              this.node = _context5.sent;
              if (this.nodeOptions.es) {
                this.mixDestNode = new MediaStreamAudioDestinationNode(context, {
                  channelCount: 1,
                  channelCountMode: 'explicit'
                });
                _iterator = _createForOfIteratorHelper(this.farEndStreamToAudioSourceNode.keys());
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    stream = _step.value;
                    this.assignFarEndStreamToAudioSourceNode(stream);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                this.createMixSourceNode();
              }
              start = this.node;
              end = this.node;
              return _context5.abrupt("return", {
                start: start,
                end: end
              });
            case 15:
              _context5.prev = 15;
              _context5.t0 = _context5["catch"](4);
              // It's better to return some audio stream than nothing.
              this.failed = true;
              this.delegate.onFallback(this, _context5.t0);
              throw _context5.t0;
            case 20:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[4, 15]]);
      }));
    }
  }, {
    key: "observeMeetingAudio",
    value: function observeMeetingAudio(audioVideo) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var stream;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (this.nodeOptions.es) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              audioVideo.addAudioMixObserver(this);
              _context6.next = 5;
              return audioVideo.getCurrentMeetingAudioStream();
            case 5:
              stream = _context6.sent;
              if (stream) {
                this.addFarEndStream(stream);
              }
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "unObserveMeetingAudio",
    value: function unObserveMeetingAudio(audioVideo) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var stream;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (this.nodeOptions.es) {
                _context7.next = 2;
                break;
              }
              return _context7.abrupt("return");
            case 2:
              audioVideo.removeAudioMixObserver(this);
              _context7.next = 5;
              return audioVideo.getCurrentMeetingAudioStream();
            case 5:
              stream = _context7.sent;
              if (stream) {
                this.removeFarendStream(stream);
              }
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
    }
    /**
     * Add an observer to receive notifications about Amazon Voice Focus lifecycle events.
     * See {@link VoiceFocusTransformDeviceObserver} for details.
     * If the observer has already been added, this method call has no effect.
     */
  }, {
    key: "addObserver",
    value: function addObserver(observer) {
      this.delegate.addObserver(observer);
    }
    /**
     * Remove an existing observer. If the observer has not been previously {@link
     * VoiceFocusTransformDevice.addObserver|added}, this method call has no effect.
     */
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      this.delegate.removeObserver(observer);
    }
  }, {
    key: "addFarEndStream",
    value: function addFarEndStream(activeStream) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!(!this.nodeOptions.es || !activeStream || this.farEndStreamToAudioSourceNode.has(activeStream))) {
                _context8.next = 2;
                break;
              }
              return _context8.abrupt("return");
            case 2:
              if (this.node) {
                this.assignFarEndStreamToAudioSourceNode(activeStream);
              } else {
                this.farEndStreamToAudioSourceNode.set(activeStream, null);
              }
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "removeFarendStream",
    value: function removeFarendStream(inactiveStream) {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              (_a = this.farEndStreamToAudioSourceNode.get(inactiveStream)) === null || _a === void 0 ? void 0 : _a.disconnect();
              this.farEndStreamToAudioSourceNode.delete(inactiveStream);
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "meetingAudioStreamBecameActive",
    value: function meetingAudioStreamBecameActive(activeStream) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              this.addFarEndStream(activeStream);
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "meetingAudioStreamBecameInactive",
    value: function meetingAudioStreamBecameInactive(inactiveStream) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              this.removeFarendStream(inactiveStream);
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "assignFarEndStreamToAudioSourceNode",
    value: function assignFarEndStreamToAudioSourceNode(streamToAdd) {
      var streamNodeToAdd = this.node.context.createMediaStreamSource(streamToAdd);
      streamNodeToAdd.channelCount = 1;
      streamNodeToAdd.channelCountMode = 'explicit';
      this.farEndStreamToAudioSourceNode.set(streamToAdd, streamNodeToAdd);
      streamNodeToAdd.connect(this.mixDestNode, 0);
    }
  }, {
    key: "createMixSourceNode",
    value: function createMixSourceNode() {
      this.mixSourceNode = this.node.context.createMediaStreamSource(this.mixDestNode.stream);
      this.mixSourceNode.channelCount = 1;
      this.mixSourceNode.channelCountMode = 'explicit';
      this.mixSourceNode.connect(this.node, 0, 1);
    }
  }]);
  return VoiceFocusTransformDevice;
}();
function isDefaultDevice(device) {
  if (device === 'default') {
    return true;
  }
  if (!device || typeof device !== 'object') {
    return false;
  }
  if ('deviceId' in device && device.deviceId === 'default') {
    return true;
  }
  if ('id' in device && device.id === 'default') {
    return true;
  }
  return false;
}
exports.default = VoiceFocusTransformDevice;